import React from 'react';

import styled from 'styled-components';

import { useTranslation } from 'lib/i18n';

import { mediaSelector } from 'helpers/style-utils';

import AboutHeader from 'components/about/header/AboutHeader';
import AboutFooter from 'components/about/footer/AboutFooter';
import AboutBlock from 'components/about/AboutBlock';

import TosNavigation from './TosNavigation';
import TosText from './TosText';

const StyledTosPage = styled.div`
  background: ${p => p.theme.currentTheme.body};
`;

const Layout = styled.div`
  margin: 60px auto 60px auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  ${mediaSelector.mobile} {
    margin: 0 auto 10px auto;
  }
`;

const Header = styled.h1`
  font-size: 12rem;
  line-height: 9.6rem;
  letter-spacing: -0.04em;
  text-align: center;
  padding-top: 56px;

  ${mediaSelector.mobile} {
    font-size: 4.8rem;
    line-height: 4.32rem;
  }
`;

export const PAGES = ['tos', 'privacy'] as const;

export type PageNames = typeof PAGES[number];

type Props = {
  pageName: PageNames;
};

const TosPage: React.FC<Props> = ({ pageName }) => {
  const { t } = useTranslation('tos');

  return (
    <StyledTosPage>
      <AboutHeader />
      <Header>{t(`${pageName}.header`)}</Header>
      <AboutBlock>
        <Layout>
          <TosNavigation pageName={pageName} />
          <TosText pageName={pageName} />
        </Layout>
      </AboutBlock>
      <AboutFooter />
    </StyledTosPage>
  );
};

export default TosPage;
